import '../styles/LoginInstrumentReference.css';
import React from 'react';

const CUSTODY_STAGES = [
  { id: 'picked-up', label: 'Picked Up', note: 'Custody received from the sender' },
  { id: 'in-transit', label: 'In Transit', note: 'Moving along the consignment route' },
  { id: 'customs', label: 'Customs', note: 'Held for clearance checks' },
  { id: 'out-for-delivery', label: 'Out for Delivery', note: 'On the final leg to the recipient' },
  { id: 'delivered', label: 'Delivered', note: 'Handed over and the record closes' },
];

function LoginInstrumentReference() {
  return (
    <section
      className="ir-root"
      aria-labelledby="ir-title"
      data-section="LoginInstrumentReference"
    >
      <div className="ir-inner">
        <div className="ir-head">
          <span className="ir-eyebrow">
            <span className="ir-eyebrow-line" aria-hidden="true" />
            Custody Scale
          </span>
          <h2 id="ir-title" className="ir-title">
            The custody stages a shipment moves through
          </h2>
        </div>

        <div className="ir-scale-wrap">
          <div
            className="ir-tick"
            aria-hidden="true"
            style={{ left: '10%' }}
          />
          <ol className="ir-scale" aria-label="Consignment custody stages">
            {CUSTODY_STAGES.map((stage, index) => {
              const isTerminal = stage.id === 'delivered';
              const isActive = index === 0;
              const modifier = isTerminal
                ? ' ir-stage--terminal'
                : isActive
                ? ' ir-stage--active'
                : '';
              return (
                <li
                  key={stage.id}
                  className={'ir-stage' + modifier}
                >
                  <span className="ir-stage-idx" aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <span className="ir-stage-body">
                    <span className="ir-stage-label">{stage.label}</span>
                    <span className="ir-stage-note">{stage.note}</span>
                  </span>
                </li>
              );
            })}
          </ol>
        </div>

        <div className="ir-note">
          <span className="ir-note-mark" aria-hidden="true" />
          <p className="ir-note-text">
            A verified account keeps a consignment shipment&rsquo;s record attached to its
            sender or recipient &mdash; retrievable on a later visit, with the same waybill,
            route and stage the instrument reads here.
          </p>
        </div>
      </div>
    </section>
  );
}

export default LoginInstrumentReference;